import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Включённость и уровень шумодава переживают перезаход в комнату; пресет,
// не секрет — localStorage. Дефолт off: пользователь включает подавление шума
// осознанно; на неподдерживаемом железе адаптер молча остаётся без него.
// level — atten_lim DeepFilterNet (дБ, 0–100): максимум ослабления шума;
// 40 — мягкий дефолт: остаётся естественный фон, меньше артефактов на голосе.
export const DEFAULT_NOISE_LEVEL = 40

interface NoiseSuppressionState {
  enabled: boolean
  level: number
  setEnabled: (enabled: boolean) => void
  setLevel: (level: number) => void
}

export const useNoiseSuppression = create<NoiseSuppressionState>()(
  persist(
    (set) => ({
      enabled: false,
      level: DEFAULT_NOISE_LEVEL,
      setEnabled: (enabled) => set({ enabled }),
      setLevel: (level) => set({ level: Math.min(100, Math.max(0, Math.round(level))) }),
    }),
    {
      name: 'telemost.noise-suppression',
      version: 1,
      // Состояние, сохранённое до появления level (только enabled), —
      // дополняется дефолтом.
      migrate: (persisted) => {
        const state = (persisted ?? {}) as Partial<NoiseSuppressionState>
        return {
          enabled: state.enabled ?? false,
          level: state.level ?? DEFAULT_NOISE_LEVEL,
        }
      },
    },
  ),
)
